import { useAuth } from '@omnipresentgroup/auth';
import { AUTH0_ROLES } from '@omnipresentgroup/constants';
import {
  Breadcrumbs,
  Inline,
  Skeleton,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useCompany } from '@omnipresentgroup/domains';
import { CompanyDetails } from '@omnipresentgroup/features';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { Loading } from '../../components';
import { CLIENT_PROFILE_PATH } from '../../constants';

export const PAGE_TITLE = 'Company profile';

export const ClientProfile = () => {
  const navigate = useNavigate();

  const { user: authUser } = useAuth();

  const clientId = useMemo(
    () =>
      authUser?.[AUTH0_ROLES].find(
        (role: { type: string }) => role.type === 'manager',
      )?.tenantId || '',
    [authUser],
  );

  const { data: client, isLoading } = useCompany({
    id: clientId,
    enabled: !!clientId,
  });

  const PageHeader = () => {
    return (
      <Stack gap="0">
        <Inline justify="space-between" minH={40} align="center">
          <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
            {isLoading ? <Skeleton width={150} /> : `${client?.name}`}
          </Typography>
        </Inline>
      </Stack>
    );
  };

  return (
    <Stack gap="16">
      <Breadcrumbs
        crumbs={[
          { id: 'home', title: 'Home', onClick: () => navigate('/') },
          {
            id: 'client',
            title: `${PAGE_TITLE}`,
            onClick: () => navigate(CLIENT_PROFILE_PATH),
          },
          {
            id: 'clientName',
            title: `${client ? `${client.name}` : ''}`,
            active: true,
          },
        ]}
      />
      <PageHeader />

      {clientId ? <CompanyDetails companyId={clientId} /> : <Loading />}
    </Stack>
  );
};
